/**
 * A custom MCP server shown as a plugin: the organization's (an admin
 * connected it for everyone) or the person's own. The row carries no account
 * action; its badge says whose it is, and opening it goes to the server's
 * page — under Plugins for a personal server, under Compliance →
 * Integrations for the organization's.
 *
 * @module components/connections/CustomMcpPluginRow
 */
import type { CustomMcpServer } from "../../state/customMcpServers";
import {
  allowedToolsLabel,
  customMcpHost,
  customMcpScopeBadge,
} from "../apps/integrations/customMcpServerContent";
import {
  CustomMcpServerIcon,
  customMcpServerStatus,
} from "../apps/integrations/CustomMcpServerRow";
import { Button } from "../ui/button";

export function CustomMcpPluginRow({
  server,
  onOpen,
}: {
  readonly server: CustomMcpServer;
  readonly onOpen: (serverId: string) => void;
}) {
  const status = customMcpServerStatus(server);
  return (
    <div className="relative -mx-3 flex min-w-0 items-center">
      <Button
        variant="ghost"
        className="h-auto min-w-0 flex-1 justify-start gap-3 px-3 py-2.5 text-left font-normal whitespace-normal sm:h-auto"
        onClick={() => onOpen(server.id)}
      >
        <CustomMcpServerIcon className="size-10" />
        <span className="min-w-0 flex-1 pr-28">
          <span className="block truncate text-sm font-medium text-foreground">{server.name}</span>
          <span className="block truncate text-sm text-muted-foreground">
            MCP · {customMcpHost(server.url)} · {allowedToolsLabel(server.tools)}
          </span>
        </span>
      </Button>
      <span
        className={`pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 rounded-full px-2 py-0.5 text-[11px] ${status.className}`}
      >
        {server.enabled
          ? customMcpScopeBadge(server.scope)
          : `${customMcpScopeBadge(server.scope)} · ${status.label}`}
      </span>
    </div>
  );
}
